/*global angular */
'use strict';

angular.module('MrDWebApp')
.controller('ConfirmAddressCtrl', function($scope, $state) {

  var _confirm_address = this;

  _confirm_address.initAutocomplete = function () {

    $scope._rc.autocompleteSessionToken = new google.maps.places.AutocompleteSessionToken();
    $scope._rc.autocompleteService = new google.maps.places.AutocompleteService();
    $scope._rc.s = new google.maps.places.PlacesService(document.createElement('div')); // Why the div? Because Google docs says

  };

  _confirm_address.initAutocomplete();

  _confirm_address.goToRestaurants = function(){
      $scope._rc.clearCart();
      $state.go('location', {
        lat: $scope._rc.variables.address.latitude,
        lng: $scope._rc.variables.address.longitude,
        street_name: $scope._rc.variables.address.street_name
      });
  };

  $scope._rc.bodyClass = 'html-grey';

});
